import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';

export default responsiveFontSizes(
  createTheme({
    breakpoints: {
      values: {
        xs: 320,
        sm: 600,
        md: 720,
        lg: 1280,
        xl: 1400,
      },
    },
    typography: {
      fontFamily:
        'BundesSans, Verdana, Arial, Helvetica, --apple-system, sans-serif',
      h1: {
        fontWeight: 700,
        fontSize: 42,
        letterSpacing: 0,
        fontFamily: 'BundesSans, sans-serif',
        lineHeight: 1.2,
      },
      h2: {
        fontWeight: 700,
        fontSize: 42,
        letterSpacing: 0,
        fontFamily: 'BundesSans, sans-serif',
        lineHeight: 1.2,
      },
      h3: {
        fontWeight: 700,
        fontSize: 24,
        letterSpacing: 0,
        fontFamily: 'BundesSans, sans-serif',
        lineHeight: 1.2,
      },
      h4: {
        fontWeight: 700,
        fontSize: 20,
        letterSpacing: 0,
        fontFamily: 'BundesSans, sans-serif',
        lineHeight: 1.2,
      },
      h5: {
        fontSize: 16,
        fontWeight: 700,
        lineHeight: 1.2,
        fontFamily: 'BundesSans, sans-serif',
      },
      h6: {
        fontSize: 14,
        fontWeight: 700,
        lineHeight: 1.2,
        fontFamily: 'BundesSans, sans-serif',
      },
      body1: {
        fontFamily: 'BundesSerif, serif',
      },
      body2: {},
      caption: {
        fontSize: 12,
        color: '#576164',
        lineHeight: '16px',
      },
      subtitle1: {},
      subtitle2: {
        fontSize: 18,
      },
      button: {
        fontSize: 16,
        letterSpacing: 0,
        textTransform: 'none',
        fontWeight: 'bold',
      },
      overline: {},
    },
    palette: {
      common: {
        black: '#000',
        white: '#fff',
      },
      background: {
        paper: '#fff',
        default: '#fff',
      },
      primary: {
        main: '#63a615',
        light: '#ebf7dd',
        dark: '#375F15',
        contrastText: '#fff',
      },
      secondary: {
        main: '#44741A',
      },
      error: {
        light: 'rgba(231, 153, 181, 1)',
        main: 'rgba(196, 0, 70, 1)',
        dark: 'rgba(137, 13, 72, 1)',
        contrastText: '#fff',
      },
      text: {
        primary: '#303030',
        secondary: 'rgba(0, 0, 0, 0.54)',
        disabled: 'rgba(0, 0, 0, 0.38)',
        hint: 'rgba(0, 0, 0, 0.38)',
      },
    },
    overrides: {
      MuiInputLabel: {
        root: {
          fontFamily: 'BundesSans',
        },
      },
      MuiInputBase: {
        root: {
          fontFamily: 'BundesSans',
        },
      },
      MuiFormControlLabel: {
        label: {
          fontFamily: 'BundesSans',
          lineHeight: 1.2,
        },
      },
      MuiFormHelperText: {
        root: {
          fontSize: '0.875rem',
        },
      },
      MuiLink: {
        root: {
          color: '#303030',
          borderBottom: '1px solid #63a615',
          textDecoration: 'none',
          '&:hover': {
            color: '#63a615',
          },
          fontFamily: 'BundesSerif',
        },
        underlineHover: {
          '&:hover': {
            textDecoration: 'none',
          },
        },
      },
      MuiRadio: {
        colorSecondary: {
          '&$checked': {
            color: '#80b640',
          },
        },
      },
    },
  })
);
